const rolloverTexts = async function () {
    const sc = document.querySelector('.sc-rollover-texts') !== null;

    if (sc) {
        let texts = document.querySelectorAll('.sc-rollover-texts__hover');

        texts.forEach((e) => {
            e.addEventListener('mouseover', () => {
                const hoverImage = e.getAttribute('data-hover');

                document.querySelector(`.${hoverImage}`).classList.add('z-40');
            })

            e.addEventListener('mouseleave', () => {
                const hoverImage = e.getAttribute('data-hover');

                document.querySelector(`.${hoverImage}`).classList.remove('z-40');
            })
        })
    }
}

export const init = rolloverTexts;